import SnapshotBar from './SnapshotBar';

export default SnapshotBar;
